<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="发送邮箱" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.email" placeholder="请输入邮箱">
						</el-input>
					</el-form-item>
					<el-form-item label="标题" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.emailTitle" placeholder="请输入标题">
						</el-input>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button type="primary" @click="toyj()">发送邮件</el-button>
							<el-button @click="empty">清空</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="userList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="tableLoading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column prop="email" label="发送邮箱"  align="center" width="90">
				<template slot-scope="scope">
					<el-button type="primary" @click="look(scope.row.email,1)">查看</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="emailTitle" label="标题" align="center" :show-overflow-tooltip="true" >
			</el-table-column>
			<el-table-column prop="failEmail" label="失败邮箱" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button type="primary" @click="look(scope.row.failEmail,2)">查看</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="reason" label="失败原因" align="center" :show-overflow-tooltip="true" >
				<template slot-scope="scope">
					<el-button type="primary" @click="look(scope.row.reason,3)">查看</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="createBy" label="创建人" align="center" :show-overflow-tooltip="true" >
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center" :show-overflow-tooltip="true"
				:formatter="changeNull">
			</el-table-column>
		</el-table>
		<!-- :current-page="userList.pageNum" -->
		<el-pagination style="margin: 20px 0px 20px 0px ;" background :current-page="1"
			@current-change="pageChange" :page-sizes="[10, 20, 50, 100, 150, 200,300,400,500]"
			layout="total, sizes, prev, pager, next, jumper" :total="userList.total" @size-change="handleSizeChange">
		</el-pagination>

		<!-- 发送邮件 -->
		<el-dialog style="float:rigin" center title="发送邮件" :visible.sync="emailvisible" :close-on-click-modal="false"
			width="50%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<div style="text-align: start;margin: 10px 0;font-size: 16rpx;font-weight: 700;">邮箱地址：
						<div style="height: 10px;"></div>
						<el-input type="textarea" v-model="emailInfo.email"  placeholder="请输入接收人邮箱地址，多个请使用;分隔" />
					</div>
					<div style="text-align: start;margin: 10px 0;font-size: 16rpx;font-weight: 700;">邮件标题：
					<div style="height: 10px;"></div>
						<el-input type="text" v-model="emailInfo.emailTitle" placeholder="请输入邮件标题" />
					</div>
					<div style="margin-top: 10px;">
						<div style="text-align: start;margin: 10px 0;font-size: 16rpx;
						font-weight: 700;display: flex;justify-content: space-between;">
						邮件内容:
						<div style="display: flex;justify-content: space-between;">
							<!-- <div  style="margin-right: 10px;font-weight:normal;">
								<span class="active">常用模板1</span> 
								<span class="active1">常用模板2</span> 
								<span class="active1">常用模板3</span> 
							</div> -->
							<div @click="mb"> 
								更多模板
								<i class="el-icon-arrow-right"></i>
							</div>
						</div>
						</div>
						<el-form-item>
							<div id="lpc-quill" class="quill" style="width: 100%; height:520px">
								<el-upload class="upload-demo1" v-show="false" ref="upload" :action="httpUrl"
									:before-upload="beforeAvatarUpload1" :on-success="upScuccess1" :on-error="uploadError" />
								<quill-editor v-model="emailInfo.emailContent" ref="myQuillEditor1" 
								class="editer1" :options="editorOption1" style="height:500px"
									@ready="onEditorReady($event)">
								</quill-editor>
							</div>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="emailvisible = false">取 消</el-button>
				<el-button type="primary" @click="send()" >确 定</el-button>
			</div>
		</el-dialog>
		<!-- 模板 -->
		<el-dialog style="float:rigin" center :title="isadd?'新增模板':'编辑模板'" :visible.sync="addmbvisible" :close-on-click-modal="false"
			width="50%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<div style="text-align: start;margin: 10px 0;font-size: 16rpx;font-weight: 700;">模板标题：
						<div style="height: 10px;"></div>
						<el-input type="text" v-model="mbinfo.emailTitle" placeholder="请输入模板标题" />
					</div>
					<div style="text-align: start;margin: 10px 0;font-size: 16rpx;font-weight: 700;">邮件标题：
					<div style="height: 10px;"></div>
						<el-input type="text" v-model="mbinfo.emailSubtitle" placeholder="请输入邮件标题" />
					</div>
					<div>
						<div style="text-align: start;margin: 10px 0;font-size: 16rpx;font-weight: 700;display: flex;justify-content: space-between;">
						邮件内容:
					
						</div>
						<el-form-item>
							<div id="lpc-quill" class="quill" style="width: 100%; height:520px">
								<el-upload class="upload-demo" v-show="false" ref="upload" :action="httpUrl"
									:before-upload="beforeAvatarUpload" :on-success="upScuccess" :on-error="uploadError" />
								<quill-editor v-model="mbinfo.emailContent" ref="myQuillEditor" 
								class="editer" :options="editorOption" style="height:500px"
									@ready="onEditorReady($event)">
								</quill-editor>
							</div>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="addmbvisible = false">取 消</el-button>
				<el-button type="primary" @click="editmb()" v-if="!isadd">确 定</el-button>
				<el-button type="primary" @click="setaddmb()" v-else>确 定</el-button>
			</div>
		</el-dialog>
		
		<el-dialog style="float:rigin" center title="邮件模板列表" :visible.sync="mbvisible" :show-close="false" :close-on-click-modal="false"
			width="50%" >
			<div slot="title" class="dialog-footer" style="position: relative;">
				   邮件模板列表
				
			
			  </div>
			 <div style="position: absolute;top: 20px;right: 30px;font-size: 16px;color: black;" @click="addmb">增加模板</div>
			<div class="app-container" style="text-align: center;">
				 <el-radio-group v-model="radios" style="display: flex;flex-wrap: wrap;gap: 20px 0;">
				    <el-radio :label="item.id" v-for="item in mblist">{{item.emailTitle}}
						<i @click="addmb(item)" class="el-icon-edit-outline"></i>
					</el-radio>
				   
				  </el-radio-group>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="mbvisible = false">取 消</el-button>
				<el-button type="primary" @click="mbset()" >确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog style="float:rigin" center :title="emailtitle" :visible.sync="emailflag" :show-close="false" :close-on-click-modal="false"
			width="50%" >
			
			<div class="app-container" style="text-align: left;" >
				{{emailresonInfo}}
			</div>
			
			<div slot="footer" class="dialog-footer">
				<el-button @click="emailflag = false">关 闭</el-button>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('user');
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				cylist:[],
				mblist:[],
				radios:0,
				httpUrl: urls,
				tableLoading: false, //表格
				resetPassLoading: false, //重置密码
				sureLoading:false, //充值
				inviteDataLoading: false, //邀请关系表格
				editUserLoading: false, // 编辑
				userList: [{}], //用户列表
				inviteDialogVisible: false,
				details:"",
				dialogVisible: false,
				editDialogVisible: false,
				editUserDialogVisible: false, // 编辑用户弹窗
				integralId: "", //积分id
				integralList: [],
				appropriation: "",
				isadd:false,
				ids: '', //授权用户id
				userData: [{}], //用户角色列表
				userDataList: [], //用户角色列表选中的
				formLabelWidth: "100px",
				form: {
					username: "",
					password: "",
					surePass: ""
				},
				mainFormRules: {
					username: {
						required: true,
						message: "请输入账号",
						trigger: "blur"
					},
					password: {
						required: true,
						message: "请输入密码",
						trigger: "blur"
					},
				},
				page: {
					pageNum: 1,
					pageSize: 10,
					invitePageNum: 1,
					invitePageSize: 10,

					WGPageNum: 1,
					WGPageSize: 10,
				},
				searchInfo: {
					isEnable: '',
					isSubscribe: '',
					orderType: 1
				},
				inviteData: [],
				setTLevelData: {
					agentLevel: "",
					provinceId: "",
					cityId: "",
					areaId: "",
					status: false,
					userId: "",
					id: "",
					data: [{
							name: ""
						},
						{
							name: ""
						},
						{
							name: ""
						}
					]
				},
				provinceId: '',
				cityId: '',
				areaId: '',
				provinceList: {}, //省
				cityList: {}, //市
				districtList: {}, //区
				userForm: {},
				logo: "",
				payUserName:'', //充值用户
				rechargeType:1, //充值类型
				fileList: [], //充值图片
				goodsImages: [],
				cidImages:[],
				remark:'', //充值备注
				emailvisible:false,
				editAgentDialogVisible: false, // 设置代理弹窗
				editAgentLoading: false, //设置代理
				userId: '',
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
									header: 1,
								},
								{
									header: 2,
								},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
									list: "ordered",
								},
								{
									list: "bullet",
								},
								], // 列表
								[{
									script: "sub",
								},
								{
									script: "super",
								},
								], // 上下标
								[{
									indent: "-1",
								},
								{
									indent: "+1",
								},
								], // 缩进
								[{
									direction: "rtl",
								},], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								},], // 字体大小
								[{
									color: [],
								},
								{
									background: [],
								},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								},], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							
							handlers: {
								image: function (value) {
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},
				
						},
					},
					theme: "snow",
				},
				editorOption1: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
									header: 1,
								},
								{
									header: 2,
								},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
									list: "ordered",
								},
								{
									list: "bullet",
								},
								], // 列表
								[{
									script: "sub",
								},
								{
									script: "super",
								},
								], // 上下标
								[{
									indent: "-1",
								},
								{
									indent: "+1",
								},
								], // 缩进
								[{
									direction: "rtl",
								},], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								},], // 字体大小
								[{
									color: [],
								},
								{
									background: [],
								},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								},], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							
							handlers: {
								image: function (value) {
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo1 input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},
				
						},
					},
					theme: "snow",
				},
				userPropertyList: [],
				propertyDialogVisible: false,
				loadingUserProperty: false,

				//网体归属
				wtDialogVisible: false,
				twData: {},
				mbinfo:{},
				wgid:'',
				emailInfo:{},
				loadingTwo: false,
				mbvisible:false,
				addmbvisible:false,
				mbId:'',
				emailtitle:'',
				emai:'',
				emailflag:false,
				emailresonInfo:{}
			};
		},

		methods: {
			look(e,i){
				this.emailflag=true
				this.emailresonInfo=e
				this.emai=i
				if(i==1){
					this.emailtitle='发送邮箱'
				}
				if(i==2){
					
					this.emailtitle='失败邮箱'
				}
				if(i==3){
					this.emailtitle='失败原因'
					
				}
			},
			send(){
				this.$api.sendEmail({...this.emailInfo}).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.$api.findListemail().then(res=>{
							this.mblist=res.data.list
						})
						setTimeout(()=>{
							this.emailvisible = false;
						},1000)
					} else {
						this.$message.error(res.message);
					}
				})
			},
			
			changeNull(row, column, cellValue) {
				if (cellValue) {
					return cellValue;
				} else if (cellValue == 0) {
					return "0";
				} else {
					return "暂无";
				}
			},
			mbset(){
				this.mbId=this.radios
				this.mbvisible=false
				this.$api.findbyIdListemail(this.mbId).then(res=>{
					console.log(res);
					this.emailInfo=res.data
				})
			},
			setaddmb(){
				this.$api.addmail({...this.mbinfo}).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.$api.findListemail().then(res=>{
							this.mblist=res.data.list
						})
						setTimeout(()=>{
							this.addmbvisible = false;
						},1000)
					} else {
						this.$message.error(res.message);
					}
				})
			},
			editmb(){
				this.$api.editemail({...this.mbinfo}).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.$api.findListemail().then(res=>{
							console.log(res.data.list);
							this.mblist=res.data.list
						})
						setTimeout(()=>{
							this.addmbvisible = false;
						},1000)
					} else {
						this.$message.error(res.message);
					}
				})
			},
			addmb(e){
				if(e.id){
					this.isadd=false
					this.$api.findbyIdListemail(e.id).then(res=>{
						console.log(res);
						this.mbinfo=res.data
					})
				}else{
					this.isadd=true
					this.mbinfo={}
				}
				this.addmbvisible=true
			},
			mb(){
				this.mbvisible=true
				this.$api.findListemail().then(res=>{
					console.log(res.data.list);
					this.mblist=res.data.list
				})
			},
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
					return false;
				}
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				}
				return isLt2M, imgStr;
			},
			upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.data !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			beforeAvatarUpload1(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
					return false;
				}
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				}
				return isLt2M, imgStr;
			},
			upScuccess1(res, file) {
				const quill = this.$refs.myQuillEditor1.quill; 
				if (res.state == "success" && res.data !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			uploadError() {
				this.$message.error("图片上传失败");
			},
			onEditorReady(editor) {
				// 准备编辑器
				// console.log(editor);
			},
			
			toyj(){
				this.emailInfo={}
				this.emailvisible=true
			},
			
			pageWgChange(data) { //网体归属
				// console.log(data);
				this.page.WGPageNum = data
				this.getOwnership()
			},
			handleWgSizeChange(val) { //网体归属
				this.page.WGPageSize = val
				this.getOwnership()
			},

			handleRemove(file, fileList) {
				if (file.response) {
					this.goodsImages.remove(file.response.message);
				}
				// this.goodsImages.remove(file.url);
				this.fileList = this.fileList.filter(item => item.uid !== file.uid)
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			onSuccess1(response, file) {
				console.log(response)
				this.goodsImages.push(response.message)
				this.fileList.push({
					"url": response.message
				})
				console.log("asda", this.fileList)
			},
			
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getUserList()
			},
			
			
			validateInput() {
				if (this.appropriation < 0) {
					// 输入的是负数，清空输入框的值
					this.appropriation = '';
				}
			},
			//提交充值
			sure() {
				this.sureLoading = true
				this.fileList.map(item => {
					console.log(item.url)
					this.cidImages.push(item.url)
				})
				let data = {
					userId: this.ids,
					integralId: this.integralId,
					amount: this.appropriation,
					rechargeMemo:this.remark,
					certificateImg:this.cidImages.join(','),
					type:this.rechargeType,
				}
				this.$api.getIntegralGly(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.getUserList()
						this.dialogVisible = false;
					} else {
						this.$message.error(res.message);
					}
					this.sureLoading = false
				})
			},
			//删除
			toDelete(id) {
				this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.deleteSysUser(id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getUserList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			formartDate(row, column) {
				var ymdhis = "";
				if (row) {
					var time = new Date(row);
					ymdhis += time.getFullYear() + "-";
					ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1)) + "-";
					ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
					ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
					ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
					ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
					return ymdhis;
				} else {
					return '无';
				}

			},
			pageChange(data) {
				this.page.pageNum = data
				this.getUserList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getUserList()
			},
			getUserList() {
				this.tableLoading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
				}
				this.$api.findsysEmailSendingLogList(data).then((res) => { //会员列表
					if (res.state == 'success') {
						// console.log('表格数据--',res.data.list[0])
						this.userList = res.data
						this.tableLoading = false
					}else{
						this.$message({
							type: 'error',
							message: res.message
						});
					}
				})
			},
			
		},
		created() {
			this.getUserList();
			
		}
	};
</script>

<style scoped>
	.demo-table-expand {
		font-size: 0;
		margin-left: 70px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}
	
	.active{
		color: #1d99f7;
		font-weight: 700;
	}
</style>